import type { ReactNode } from 'react';
import styles from './EmptyState.module.scss';

interface EmptyStateProps {
  title: string;
  description?: ReactNode;
  action?: ReactNode;
  tone?: 'neutral' | 'critical';
}

export function EmptyState({ title, description, action, tone = 'neutral' }: EmptyStateProps) {
  return (
    <div className={`${styles.empty} ${styles[tone]}`}>
      <strong className={styles.title}>{title}</strong>
      {description && <p className={styles.description}>{description}</p>}
      {action && <div className={styles.action}>{action}</div>}
    </div>
  );
}
